import "./SingleRecentWorkTemplate.module.css"
import PulseThreadEntry from "@/reusable_sections/Header"
import SingleRecentWorkTemplateSection from "./sections/SingleRecentWorkTemplateSection"
import Footer from "@/reusable_sections/Footer"

export default function SingleRecentWorkTemplatePage() {

  return (
    <div>
      <PulseThreadEntry />
      <SingleRecentWorkTemplateSection />
      <Footer />
    </div>
  )
}
